<template>
  <div v-b-tooltip.hover
       style="cursor: help"
       :title="egiszRecord.is_valid ? $t('data_is_valid') : $t('data_is_invalid')">
    <span v-if="egiszRecord.is_valid">✅</span>
    <span v-if="!egiszRecord.is_valid">❗</span>
  </div>
</template>

<script setup>
defineProps({
  egiszRecord: {
    type: Object
  }
})
</script>
